var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hidden lg:flex pt-20 items-end"},[_c('img',{staticClass:"object-contain",attrs:{"src":"https://assets.parkos.com/assets/img/static-pages/team-with-text.png","alt":_vm.$i18n('faq.cs-team-picture'),"width":"310px","height":"288px","loading":"lazy"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }